import { render, staticRenderFns } from "./UserControlPage.vue?vue&type=template&id=98ff914a&scoped=true&"
import script from "./UserControlPage.vue?vue&type=script&lang=js&"
export * from "./UserControlPage.vue?vue&type=script&lang=js&"
import style0 from "./UserControlPage.vue?vue&type=style&index=0&id=98ff914a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ff914a",
  null
  
)

export default component.exports